import { render, staticRenderFns } from "./addressTMS.vue?vue&type=template&id=1ef0c5a4&scoped=true&"
import script from "./addressTMS.vue?vue&type=script&lang=js&"
export * from "./addressTMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef0c5a4",
  null
  
)

export default component.exports